/* Menü-drawer — alleen het wisselen van tab en de sluitknop.
 *
 * Al het andere (openen, sluiten, schuiven tussen niveaus, focus-trap,
 * scroll-lock, taal-/landkiezer) blijft van assets/theme.js. Dit bestand
 * voegt uitsluitend toe wat het thema niet kent: tabs.
 *
 * Waarom de sluitknop hier staat en niet in theme.js: de oude drawer had er
 * geen. De engine bindt wel `close` aan de overlay, dus we klikken die aan —
 * zo loopt het sluiten via precies dezelfde weg als altijd, inclusief het
 * herstellen van de scrollpositie.
 */
(function () {
  'use strict';

  function init(root) {
    var tabs = root.querySelectorAll('[data-cl-menu-tab]');
    if (!tabs.length) return;

    var primary = root.querySelector('[data-primary-container]');
    var hoofd = root.querySelector('[data-main]');
    var saleBars = root.querySelectorAll('[data-cl-menu-sale]');
    var overlay = root.querySelector('[data-overlay]');
    var closeBtn = root.querySelector('[data-cl-menu-close]');

    /* [data-main] heeft overflow:hidden; theme.js zet er een inline hoogte op
       zodat de scrollbak weet hoe hoog de open lijst is (het submenu staat
       absoluut en telt zelf niet mee). Die engine kent onze tabs niet: na een
       tabwissel staat de hoogte van de vorige tab er nog. Te kort betekent
       weggeknipte collecties zonder scrollbalk, te lang betekent loze ruimte.
       De +8 is dezelfde marge die theme.js hanteert. */
    function zetHoogte() {
      if (!hoofd || !primary) return;
      if (!root.classList.contains('active')) return;   // dicht: theme.js meet bij openen
      hoofd.style.height = primary.offsetHeight + 8 + 'px';
    }

    /* Openstaande subniveaus dichtklappen door de terugknop van het thema aan
       te klikken — van diep naar ondiep. Zo blijft de dieptelling in theme.js
       kloppen; die zelf resetten zou de teller uit de pas laten lopen. */
    function sluitSubniveaus() {
      var open = root.querySelectorAll('.drawer-menu__list--sub.visible');
      for (var i = open.length - 1; i >= 0; i--) {
        var terug = open[i].querySelector('[data-item="back"]');
        if (terug) terug.click();
      }
    }

    function toonTab(index) {
      var key = String(index);
      sluitSubniveaus();

      /* Wisselen van tab hoort de zoekopdracht te wissen: anders sta je naar
         resultaten te kijken terwijl de tab eronder iets anders zegt. */
      var veld = root.querySelector('[data-cl-menu-search]');
      var resultaten = root.querySelector('[data-cl-menu-results]');
      if (veld && veld.value) {
        veld.value = '';
        var wis = root.querySelector('[data-cl-menu-search-clear]');
        if (wis) wis.hidden = true;
        if (resultaten) { resultaten.hidden = true; resultaten.innerHTML = ''; }
        var links = root.querySelector('[data-all-links]');
        if (links) links.hidden = false;
      }

      root.setAttribute('data-active-tab', key);

      for (var i = 0; i < tabs.length; i++) {
        tabs[i].setAttribute('aria-selected', tabs[i].getAttribute('data-cl-menu-tab') === key ? 'true' : 'false');
      }

      if (primary) {
        var items = primary.children;
        for (var j = 0; j < items.length; j++) {
          var t = items[j].getAttribute('data-tab');
          if (t !== null) items[j].hidden = t !== key;
        }
      }

      for (var s = 0; s < saleBars.length; s++) {
        saleBars[s].hidden = saleBars[s].getAttribute('data-cl-menu-sale') !== key;
      }

      var scroller = root.querySelector('.drawer-menu__contents');
      if (scroller) scroller.scrollTop = 0;

      zetHoogte();
    }

    for (var k = 0; k < tabs.length; k++) {
      tabs[k].addEventListener('click', function (e) {
        toonTab(e.currentTarget.getAttribute('data-cl-menu-tab'));
      });
    }

    if (closeBtn && overlay) {
      closeBtn.addEventListener('click', function () {
        overlay.click();
      });
    }

    /* ---------- zoeken in de drawer ----------
       We halen de resultaten bij `/search/suggest?section_id=predictive-search`,
       precies zoals theme.js dat voor de zoekbalk in de header doet, en zetten
       de uitkomst in een bak binnen de drawer. Dus geen tweede zoeksysteem:
       hetzelfde eindpunt, dezelfde opmaak, alleen een andere plek. */
    var zoekVeld = root.querySelector('[data-cl-menu-search]');
    var wisKnop = root.querySelector('[data-cl-menu-search-clear]');
    var bak = root.querySelector('[data-cl-menu-results]');
    var lijst = root.querySelector('[data-all-links]');
    var saleBars = root.querySelectorAll('[data-cl-menu-sale]');

    var cache = {};
    var wachtend = null;
    var laatste = 0;

    function toonMenu() {
      bak.hidden = true;
      bak.innerHTML = '';
      lijst.hidden = false;
      for (var s = 0; s < saleBars.length; s++) {
        saleBars[s].hidden = saleBars[s].getAttribute('data-cl-menu-sale') !== root.getAttribute('data-active-tab');
      }
    }

    function toonResultaten(html) {
      bak.innerHTML = html;
      bak.hidden = false;
      lijst.hidden = true;
      // sale-bar hoort niet boven zoekresultaten
      for (var s = 0; s < saleBars.length; s++) saleBars[s].hidden = true;
      bak.scrollTop = 0;
    }

    function zoek(term) {
      if (cache[term]) { toonResultaten(cache[term]); return; }
      var beurt = ++laatste;
      var p = new URLSearchParams();
      p.set('section_id', 'predictive-search');
      p.set('q', term);
      if (window.theme && window.theme.searchableFields) {
        p.set('resources[options][fields]', window.theme.searchableFields);
      }
      var basis = (window.theme && window.theme.routes && window.theme.routes.predictive_search_url) || '/search/suggest';

      fetch(basis + '?' + p)
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (t) {
          if (beurt !== laatste) return;              // een nieuwere aanslag won
          var doc = new DOMParser().parseFromString(t, 'text/html');
          var sectie = doc.querySelector('#shopify-section-predictive-search');
          var html = sectie ? sectie.innerHTML : '';
          cache[term] = html;
          toonResultaten(html);
        })
        .catch(function () { /* stil: het menu blijft gewoon staan */ });
    }

    if (zoekVeld && bak && lijst) {
      zoekVeld.addEventListener('input', function () {
        var term = zoekVeld.value.trim();
        if (wisKnop) wisKnop.hidden = term.length === 0;
        clearTimeout(wachtend);
        if (term.length < 2) { toonMenu(); return; }
        wachtend = setTimeout(function () { zoek(term); }, 250);
      });

      // Enter voert de gewone zoekopdracht uit (naar /search) — dat mag blijven.
      if (wisKnop) {
        wisKnop.addEventListener('click', function () {
          zoekVeld.value = '';
          wisKnop.hidden = true;
          toonMenu();
          zoekVeld.focus();
        });
      }
    }

    toonTab(root.getAttribute('data-active-tab') || '0');
  }

  function start() {
    var root = document.querySelector('.cl-menu[data-drawer-menu]');
    if (root) init(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* De theme-editor hertekent secties; dan opnieuw initialiseren. */
  document.addEventListener('shopify:section:load', start);
})();
